const getServerName = () => {
  return window.location.hostname === 'localhost'
    ? 'localhost:3000'
    : window.location.hostname;
};

export default getServerName;
